"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var useSessionStorage = new Boolean(window.USE_SESSION_STORAGE);
var storageDriver;
var getDriver = function () {
    if (storageDriver && window.USE_SESSION_STORAGE === useSessionStorage) {
        return storageDriver;
    }
    try {
        useSessionStorage = new Boolean(window.USE_SESSION_STORAGE);
        var storage_1 = window.USE_SESSION_STORAGE === true && typeof sessionStorage !== 'undefined' ? sessionStorage : localStorage;
        var tempKey = '__storage_test__';
        storage_1.setItem(tempKey, tempKey);
        storage_1.removeItem(tempKey);
        return (storageDriver = storage_1);
    }
    catch (e) {
        return (storageDriver = 'cookie');
    }
};
var serialize = function (value) {
    if (value === null || value === undefined) {
        throw new Error('[Storage] Cannot store null or undefined values');
    }
    if (typeof value === 'string') {
        return value;
    }
    try {
        return JSON.stringify(value);
    }
    catch (_a) {
        console.error('[Storage] Error parsing value', value);
        return '';
    }
};
var deserialize = function (strValue) {
    if (strValue === null || strValue === undefined) {
        return undefined;
    }
    try {
        return JSON.parse(strValue);
    }
    catch (_a) {
        return strValue;
    }
};
var storage = {
    set: function (key, value) {
        try {
            var driver = getDriver();
            driver !== 'cookie' ? driver.setItem(key, serialize(value)) : js_cookie_1.default.set(key, serialize(value));
        }
        catch (err) {
            console.error('Error while setting data into storage.', err.message);
        }
    },
    get: function (key) {
        try {
            var driver = getDriver();
            return driver !== 'cookie' ? deserialize(driver.getItem(key)) : deserialize(js_cookie_1.default.get(key));
        }
        catch (err) {
            console.error('Error while getting data from storage.', err.message);
        }
    },
    del: function (key) {
        try {
            var driver = getDriver();
            driver !== 'cookie' ? driver.removeItem(key) : js_cookie_1.default.remove(key);
        }
        catch (err) {
            console.error('Error while deleting data from storage.', err.message);
        }
    }
};
/**
 * Exposing this logic so modules & others can access it.
 * Sometimes the browser denies access to local storage (or simply doesn't support it), so we offer a fallback
 */
window.BP_STORAGE = storage;
exports.default = storage;
